import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-3/5">
        <img
          src="https://public.readdy.ai/ai/img_res/37468d694daa0f1b62023e5df57c5d94.jpg"
          alt="Engineering Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/30 to-transparent"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/5d7361d22568520d4a403d18821c48f7.png" 
              alt="UnityCore Logo" 
              className="h-12 w-auto"
            />
          </div>
          <div className="flex items-center gap-10">
            <a href="#services" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#D4745E]' : 'text-white hover:text-[#D4745E]'}`}>Услуги</a>
            <a href="#process" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#D4745E]' : 'text-white hover:text-[#D4745E]'}`}>Процесс</a>
            <a href="#team" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#D4745E]' : 'text-white hover:text-[#D4745E]'}`}>Команда</a>
            <a href="#portfolio" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#D4745E]' : 'text-white hover:text-[#D4745E]'}`}>Портфолио</a>
            <a href="#contact" className={`text-sm font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#D4745E]' : 'text-white hover:text-[#D4745E]'}`}>Контакты</a>
          </div>
        </div>
      </nav>

      {/* Content Area */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 flex items-center min-h-screen">
        <div className="w-3/5"></div>
        <div className="w-2/5 bg-[#F8F4E8] p-16 rounded-2xl ml-auto">
          <div className="flex items-center gap-4 mb-8">
            <div className="h-0.5 w-20 bg-[#D4745E]"></div>
            <span className="text-xs font-semibold tracking-widest text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>UNITYCORE</span>
          </div>
          
          <h1 className="text-5xl font-bold text-[#2B2D42] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Техническое проектирование,<br />
            <span className="font-normal">Недвижимость и</span><br />
            <span className="italic">Инжиниринг</span>
          </h1>
          
          <p className="text-lg font-medium text-gray-600 mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            От чертежа до свидетельства о собственности (TAPU)
          </p>
          
          <p className="text-sm leading-relaxed text-gray-700 mb-12 max-w-md" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Мы берем на себя самые сложные этапы создания ваших активов в Турции. Будь то строительство виллы по индивидуальному проекту, запуск промышленного объекта или покупка готовой недвижимости — UnityCore гарантирует техническое качество и юридическую чистоту сделки для иностранных граждан.
          </p>
          
          <button 
            onClick={scrollToContact}
            className="bg-black text-white px-12 py-4 rounded-full font-semibold text-sm uppercase tracking-wide hover:bg-gray-800 transition-all flex items-center gap-3 group whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Начать проект
            <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </button>
        </div>
      </div>

      {/* Stats Card */}
      <div className="absolute bottom-12 left-12 z-20 bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-xl w-72">
        <div className="flex items-center gap-4">
          <div className="flex -space-x-3">
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#D4745E] to-[#E89580] border-3 border-white"></div>
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#2B2D42] to-[#4A5568] border-3 border-white"></div>
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#D4745E] to-[#C86550] border-3 border-white"></div>
          </div>
          <div>
            <p className="text-xl font-bold text-[#2B2D42]" style={{ fontFamily: 'Montserrat, sans-serif' }}>2000+ проектов</p>
            <p className="text-xs text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>реализовано в Турции</p>
          </div>
        </div>
      </div>
    </section>
  );
}
